import * as React from "react";
const CustomizedFormulationsSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <path
      fill="#EF4136"
      d="M23 29h4.125a4 4 0 0 0 7.75 0H45a1 1 0 1 0 0-2H34.875a4 4 0 0 0-7.75 0H23a1 1 0 0 0 0 2Zm8-3a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm14 13h-2.125a4 4 0 0 0-7.75 0H23a1 1 0 0 0 0 2h12.125a4 4 0 0 0 7.75 0H45a1 1 0 1 0 0-2Zm-6 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
    />
  </svg>
);
export default CustomizedFormulationsSVG;
